import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

import { logger } from '../../datadog';
import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { useInitTwilioSyncClient as useBaseInitTwilioSyncClient } from '../../session/sync/useInitTwilioSyncClient';
import { ConnectionError } from '../../session/types';
import { toast } from '../../toasts';
import { roomAtom } from '../../video-sdk';
import { visitorPresenceMapTwilioTokenAtom } from '../state';
import {
  RETRYING_CONNECTION_INFO_TEXT,
  RETRYING_CONNECTION_INFO_TOAST_KEY,
  TERMINAL_CONNECTION_ERROR_TEXT,
  TERMINAL_CONNECTION_ERROR_TOAST_KEY,
} from './constants';

export function useInitTwilioSyncClient() {
  const checkInSession = useAtomCallbackMemoized((get) => !!get(roomAtom), []);

  const onConnectionError = useCallback(
    (error: ConnectionError) => {
      if (checkInSession()) return;
      if (error.terminal) {
        toast.close(RETRYING_CONNECTION_INFO_TOAST_KEY);
        toast.error(TERMINAL_CONNECTION_ERROR_TEXT, {
          key: TERMINAL_CONNECTION_ERROR_TOAST_KEY,
          timeout: Infinity,
          purpose: 'system',
        });
      } else {
        logger.info('Retrying twilio sync connection (provider)');
        toast.info(RETRYING_CONNECTION_INFO_TEXT, {
          key: RETRYING_CONNECTION_INFO_TOAST_KEY,
          timeout: Infinity,
          purpose: 'system',
        });
      }
    },
    [checkInSession],
  );

  useBaseInitTwilioSyncClient({
    jwt: useAtomValue(visitorPresenceMapTwilioTokenAtom),
    onConnectionError,
  });
}
